/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getCallReportFileAction, getCallReportToExport, getCustomerCallsAction, getCustomerCallTypesAction, getCustomerContactsAction } from '../../../service/actions/callReportActions';
import { useState } from 'react';
import GSPTable, { InputFilter } from 'azm-components'
import CustomValuesHook from '../../../Hooks/customValuesHook';
import { CCol, CFormInput, CFormLabel, CFormSelect, CRow } from '@coreui/react';
import * as $ from 'jquery'
import './style.scss'
import { returnToOldId } from '../../../service/actions/commonActions';
import Paging from './paging';
import './dsapp.scss'
// import TextField from '@mui/material/TextField';


// import AdapterJalali from '@date-io/date-fns-jalali';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment-jalaali'
import { CloseSVG, DownloadIconSVG, MagnifySVG, PauseIconSVG, PlaySVG, PlusSVG, RefreshSVG, ReportQueueSVG, SearchBtnVG, SearchSVG } from '../../../components/IconSvg';
import apiCall from '../../../service/apiCall';
import { DBConfig, checkForNumericEnFaString, enToPersianChar, persianToEnglishChar } from '../../../components/helper';
import { TextField } from '@material-ui/core';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AddContact from './contact'
import { getAllContactsRequestAction } from '../../../service/actions/contactActions';
import GetContactDB from './getCantact';
import "./dsapp.scss"


const DSAppCallReport = ({
    getReport, getCallTypes, getContactReport,
    getCallTypesPending,
    getContactReportPending, getCallReportPending,
    callReport, contactReport, callTypes, returnToOld, getReportToExport, callREportToExport,
    successExport, callReportFile, getReportFile, getAllContacts }) => {

    const [values, handleChange] = CustomValuesHook({
        FromConnectTime: null, displayAddContactModal: false, numberToAddContact: '',
        refreshContact: false, isExistContactDB: false
    })
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(25)
    const [args, setArgs] = useState()

    const [eDateVal, setEDateVal] = useState(null)
    const [sDateVal, setSDateVal] = useState(null)
    const [getRecordedFileMode, setRerecordedFileMode] = useState()
    const phonebookList = useSelector((state) => state.contactReducer.unpagedPhonebook)
    const contacts = useSelector((state) => state.contactReducer.contactList)
    const ref = useRef(null);



    const [callReportObj, setCallReportObj] = useState({
        data: [],
        pageNumber: 1,
        pageSize: 25,
        totalCount: 0
    });

    useEffect(() => {

        const goftinoContext = document.getElementById("box-widget-icon")
        if (goftinoContext) {
            goftinoContext.style.display = "none"
        }
        checkIndexDB.then(
            result => {
                cachedContact()
            },
            error => console.log(error)
        )
        return (() => {
            if (goftinoContext) {
                goftinoContext.style.display = "block"
            }
        })


    }, [])

    let checkIndexDB = new Promise(function (resolve, reject) {
        //check for support
        if (!('indexedDB' in window)) {
            reject("indexedDB not supported");
        }

        var request = indexedDB.open('contacts', 1);
        request.onerror = function (event) {
            reject("Error opening DB");
        };
        request.onsuccess = function (event) {
            handleChange({ isExistContactDB: true })
            request.result.close()
            resolve(true);
        };
    });
    const cachedContact = async () => {
        setTimeout(async () => {
            ref.current.getContact()

        }, 2000)

    }
    useEffect(() => {
        if (callReportFile && getRecordedFileMode === 'download') {
            const link = document.createElement('a');
            link.href = callReportFile.Url;

            link.target = '_blank';
            // link.click();
            window.open(link.File)
        }
    }, [callReportFile])


    useEffect(() => {
        if (contacts?.data) {
            // handleChange({ allCachedContact: contacts.data })
            const rem = contacts.totalCount % (contacts.pageNumber * contacts.pageSize)
            if (rem < contacts.pageSize) {
                cachedContact()
                getReport({
                    disablePaging: false,
                    pageNumber: 1,
                    pageSize: 25,
                    sortText: "",
                    whereConditionText: ""
                })
            }
        }
    }, [contacts])






    const fileComponent = ({ item, dataList, setDataListFromItem }) => {
        const downloadFile = () => {

            setRerecordedFileMode('download')
            // getReportFile(item.RecordingId)
            // getReportFile("09b54dd2-3f6d-4c86-acc6-50ecdfa3ea19")
            apiCall.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT
            apiCall.defaults.headers.common['Content-Type'] = "application/json;charset=UTF-8"
            apiCall.get("/api/CustomerCall/RecordUrlList?RecordingId=" + item.RecordingId
                , {
                    headers: {
                        'Content-Type': "application/json;charset=UTF-8"
                    }
                })
                .then(response => {
                    var a = document.createElement('a');
                    a.setAttribute('id', "callRecordedFile");
                    a.setAttribute('target', "_blank");
                    a.href = response.data.Url;
                    document.body.appendChild(a);
                    document.getElementById('callRecordedFile').click();
                    document.body.removeChild(a);

                }).catch(err => {
                    console.log(err)
                })

        }
        const pauseAudio = () => {
            let temp = { ...dataList }
            temp.data.forEach(it => {
                it.isInPlay = false;
            })
            setDataListFromItem({ ...temp })
        }
        const playFile = () => {
            setRerecordedFileMode('play')

            // getReportFile(item.RecordingId)
            let temp = { ...dataList }
            temp.data.forEach(it => {
                it.isInPlay = false;
                it.loading = false

                if (it.CallId === item.CallId)
                    it.loading = true
            })
            setDataListFromItem({ ...temp })
            apiCall.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT
            apiCall.defaults.headers.common['Content-Type'] = "application/json;charset=UTF-8"
            apiCall.get("/api/CustomerCall/RecordUrlList?RecordingId=" + item.RecordingId
                , {
                    headers: {
                        'Content-Type': "application/json;charset=UTF-8"
                    }
                })
                .then(response => {
                    let temp = { ...dataList }
                    temp.data.forEach(it => {
                        it.isInPlay = false;
                        it.loading = false


                        if (it.CallId === item.CallId)
                            it.isInPlay = true
                        it.fileUrl = response.data.Url
                    })
                    setDataListFromItem({ ...temp })
                }).catch(err => {
                    console.log(err)
                })



        }
        return (
            <div>
                {item.RecordingId ? <div>
                    <span className='download-spn' onClick={downloadFile}>
                        <DownloadIconSVG />
                    </span>
                    {item.loading ? <span className='play-spn' onClick={playFile}>
                        <i className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></i>
                    </span>
                        : item.isInPlay ? <>
                            <span className='play-spn' onClick={pauseAudio}  >
                                <PauseIconSVG width={'20px'} height={'20px'} styles={{ marginRight: '3px' }} />
                            </span><audio src={item.fileUrl} autoPlay />
                        </> : <span className='play-spn' onClick={playFile}>
                            <PlaySVG />
                        </span>}
                </div> : <div>----</div>}
            </div>


        )
    }

    const durationCompo = ({ item }) => {
        return (
            <div>{enToPersianChar(item.Duration)}</div>
        )
    }


    const dateComp = ({ item }) => {
        return (
            <div>{enToPersianChar(item.PersianTime)}</div>
        )
    }

    const fromCompo = ({ item, setNumberToAddContact, cachedContacts }) => {
        const itemNumber = enToPersianChar(item.FromNumber.replace('+98', '0'))
        let savedContacts = cachedContacts?.filter(contact =>
            enToPersianChar(contact.defaultNumber.replace('98', '0')) === itemNumber || enToPersianChar(contact.Number2?.replace('+98', '0')) === itemNumber ||
            enToPersianChar(contact.Number3?.replace('+98', '0')) === itemNumber || enToPersianChar(contact.Number4?.replace('+98', '0')) === itemNumber)
        if (savedContacts?.length > 0) {
            return (<div className='d-flex justify-content-between' title={enToPersianChar(item.FromNumber)} >
                <span className='search-spn-cell' onClick={() => handleChange({ FromNumber: item.FromNumber })}>
                    <MagnifySVG />
                </span>
                <span style={{ fontSize: '14px' }}> {savedContacts[0].name} {savedContacts[0].familyName}</span>

            </div>)
        }
        return (
            <div className='d-flex justify-content-center'>
                {/* <span onClick={() => setNumberToAddContact(item.FromNumber)}><PlusSVG fill={'#1E72C9'} /></span> */}
                {enToPersianChar(item.FromNumber)}</div>
        )
    }

    const cardViewFromCompo = ({ item, setNumberToAddContact, cachedContacts }) => {
        const itemNumber = enToPersianChar(item.FromNumber.replace('+98', '0'))
        let savedContacts = cachedContacts?.filter(contact =>
            enToPersianChar(contact.defaultNumber.replace('98', '0')) === itemNumber || enToPersianChar(contact.Number2?.replace('+98', '0')) === itemNumber ||
            enToPersianChar(contact.Number3?.replace('+98', '0')) === itemNumber || enToPersianChar(contact.Number4?.replace('+98', '0')) === itemNumber)
        if (savedContacts?.length > 0) {
            return (<div className='text-end' title={enToPersianChar(item.FromNumber)} >
                <span className='search-spn-cell' onClick={() => handleChange({ FromNumber: item.FromNumber })}>
                    <MagnifySVG />
                </span>
                <span style={{ fontSize: '12px' }}>  {savedContacts[0].name} {savedContacts[0].familyName}</span>
                <div className='mt-2' style={{ direction: 'ltr' }}>{enToPersianChar(item.FromNumber)}</div>
            </div>)
        }
        return (
            <div className='d-flex justify-content-center' style={{ direction: 'ltr' }}>
                {/* <span className='spn-plus' onClick={() => setNumberToAddContact(item.FromNumber)}><PlusSVG fill={'#1E72C9'} />
                </span> */}
                {enToPersianChar(item.FromNumber)}</div>
        )
    }

    const toCompo = ({ item, setNumberToAddContact, cachedContacts }) => {
        const itemNumber = enToPersianChar(item.ToNumber.replace('+98', '0'))
        let savedContacts = cachedContacts?.filter(contact =>
            enToPersianChar(contact.defaultNumber.replace('98', '0')) === itemNumber || enToPersianChar(contact.Number2?.replace('+98', '0')) === itemNumber ||
            enToPersianChar(contact.Number3?.replace('+98', '0')) === itemNumber || enToPersianChar(contact.Number4?.replace('+98', '0')) === itemNumber)
        if (savedContacts?.length > 0) {
            return (<div className='d-flex justify-content-between' title={enToPersianChar(item.ToNumber)} >
                <span className='search-spn-cell' onClick={() => handleChange({ ToNumber: item.ToNumber })}>
                    <MagnifySVG />
                </span>
                <span style={{ fontSize: '12px' }}> {savedContacts[0].name} {savedContacts[0].familyName}</span>  </div>)
        }
        return (
            <div className='d-flex justify-content-center'>
                {/* <span onClick={() => setNumberToAddContact(item.ToNumber)}><PlusSVG fill={'#1E72C9'} /></span> */}
                {enToPersianChar(item.ToNumber)}</div>
        )
    }
    const cardViewToCompo = ({ item, setNumberToAddContact, cachedContacts }) => {
        const itemNumber = enToPersianChar(item.ToNumber.replace('+98', '0'))
        let savedContacts = cachedContacts?.filter(contact =>
            enToPersianChar(contact.defaultNumber.replace('98', '0')) === itemNumber || enToPersianChar(contact.Number2?.replace('+98', '0')) === itemNumber ||
            enToPersianChar(contact.Number3?.replace('+98', '0')) === itemNumber || enToPersianChar(contact.Number4?.replace('+98', '0')) === itemNumber)
        if (savedContacts?.length > 0) {
            return (<div className='text-end' title={enToPersianChar(item.ToNumber)} >
                <span className='search-spn-cell' onClick={() => handleChange({ ToNumber: item.ToNumber })}>
                    <MagnifySVG />
                </span>
                <span style={{ fontSize: '12px' }}>{savedContacts[0].name} {savedContacts[0].familyName} </span>
                <div className='mt-2' style={{ direction: 'ltr' }}>{enToPersianChar(item.ToNumber)}</div>
            </div>)
        }
        return (
            <div className='d-flex justify-content-center' style={{ direction: 'ltr' }}>
                {/* <span className='spn-plus' onClick={() => setNumberToAddContact(item.ToNumber)}><PlusSVG fill={'#1E72C9'} /></span> */}
                {enToPersianChar(item.ToNumber)}</div>
        )
    }
    const columns = [
        { title: 'تاریخ', property: 'PersianTime', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: dateComp },
        { title: 'از', property: 'FromNumber', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: fromCompo },
        { title: 'به', property: 'ToNumber', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: toCompo },
        { title: 'نتیجه', property: 'DispositionText', filterProperty: 'null', hasSort: false, hasFilter: false, display: true },
        { title: 'مدت مکالمه', property: 'Duration', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: durationCompo },
        { title: 'نوع', property: 'Type', filterProperty: 'null', hasSort: false, hasFilter: false, display: true },
        { title: 'فایل', component: fileComponent, filterProperty: 'null', hasSort: false, hasFilter: false, display: true },

    ]


    useEffect(() => {
        getReport({ PageIndex: page, PageSize: pageSize })
        getCallTypes()
        getContactReport()
        returnToOld(null, "/#/callReport/", "callReport")
    }, []);

    useEffect(() => {

        if (callReport?.data) {
            let temp = { ...callReportObj };
            temp.data = callReport.data
            temp.totalCount = callReport.TotalCount
            temp.pageNumber = page;
            temp.pageSize = pageSize;
            setCallReportObj({ ...temp })
            setTimeout(() => {
                $("#fDate").prop("readonly", false);
                $("#tDate").prop("readonly", false);

            }, 100)
        }
    }, [callReport]);

    useEffect(() => {
        setTimeout(() => {
            $("#fDate").prop("readonly", false);
            $("#tDate").prop("readonly", false);

        }, 100)
    }, [values])

    const handleCallAppToExport = () => {
        let filter = { PageIndex: 1, PageSize: 99999 };
        if (values.FromConnectTime) filter.FromConnectTime = values.FromConnectTime
        if (values.ToConnectTime) filter.ToConnectTime = values.ToConnectTime
        if (values.FromNumber) filter.FromNumber = values.FromNumber
        if (values.ToNumber) filter.ToNumber = values.ToNumber
        if (values.Type) filter.Type = values.Type
        getReportToExport(filter)

    }



    const handleGetData = (args) => {
        // let params = { ...args }
        // params.PageIndex = args.pageNumber;
        // params.PageSize = args.pageSize
        // if (values.FromConnectTime) params.FromConnectTime = values.FromConnectTime
        // if (values.ToConnectTime) params.ToConnectTime = values.ToConnectTime
        // if (values.FromNumber) params.FromNumber = values.FromNumber
        // if (values.ToNumber) params.ToNumber = values.ToNumber
        // if (values.Type) params.Type = values.Type
        // console.log(args)
        // setPage(args.pageNumber)
        // setPageSize(args.pageSize)
        // if (params.PageIndex && params.PageSize) {
        //     getReport(params)

        // }

        setPage(args.pageNumber)
        setPageSize(args.pageSize)
        setArgs({ ...args })
        let val = creatWhereCondition(args)
        if (!val.hasOwnProperty("pageNumber")) {
          val.pageNumber = 1
        }
        getReport(val)

    }

    
  const creatWhereCondition = (args) => {
    debugger
    let whereConditionText = ''
    if (values.ToNumber) whereConditionText = (whereConditionText !== '' ? ' && ' : '') + `ToNumber.Contains(\"${values.ToNumber.trim()}"\)`
    if (values.FromNumber) whereConditionText = whereConditionText + (whereConditionText !== '' ? ' && ' : '') + ` FromNumber.Contains(\"${values.FromNumber.trim()}"\)`
    if (values.Type && values.Type !== "0") whereConditionText = whereConditionText + (whereConditionText !== '' ? ' && ' : '') + `Type=${values.Type?.trim()}`
    if (values.FromConnectTime) whereConditionText = whereConditionText + (whereConditionText !== '' ? ' && ' : '') + `StartTime>=\"${new Date(new Date(`${String(values.FromConnectTime).trim()}`).setHours(0, 0, 0, 0)).toISOString().replace('T', ' ').replace('Z', ' ')}\" `
    if (values.ToConnectTime) whereConditionText = whereConditionText + (whereConditionText !== '' ? ' && ' : '') + `StartTime<=\"${new Date(new Date(`${String(values.ToConnectTime).trim()}`).setHours(23, 59, 59, 999)).toISOString().replace('T', ' ').replace('Z', ' ')}\" `
    args.whereConditionText = whereConditionText;
    args.sortText = "";
    args.disablePaging = false;
    delete args.data
    delete args.PageIndex
    delete args.filterList
    return args

  }





    const handleSearch = () => {

        // let filter = { PageIndex: 1, PageSize: pageSize };
        // if (values.FromConnectTime) filter.FromConnectTime = values.FromConnectTime
        // if (values.ToConnectTime) filter.ToConnectTime = values.ToConnectTime
        // if (values.FromNumber) filter.FromNumber = values.FromNumber
        // if (values.ToNumber) filter.ToNumber = values.ToNumber
        // if (values.Type) filter.Type = values.Type
        // getReport({ ...filter })
        let obj = { ...args }
        let val = creatWhereCondition(obj)
        val.pageNumber = 1
        setArgs({ ...val })
        getReport(val)

    }




    const handleSetNumberToAddContact = (number) => {
        handleChange({ numberToAddContact: number, displayAddContactModal: true })
    }


    const customCardView = ({
        dataList,
        dataListToDisplay,
        columns,
        setDataListFromItem,
        customProps
    }) => {
        return (
            <div className='call-report-list-custom-card-view ds-app-call-report' >
                {
                    dataList?.map((item, index) => {


                        return (
                            <div className={`call-report-card-item`} key={index}>
                                {columns.map((col, idx) => {
                                    if (col.component) {
                                        return (<div className='d-flex justify-content-between' key={idx}>

                                            <label>{col.title}:</label>
                                            <div>
                                                {col.property === 'FromNumber' ?
                                                    customProps.cardViewFromCompo({ item, index, dataList, setDataListFromItem, ...customProps }) :
                                                    col.property === 'ToNumber' ? customProps.cardViewToCompo({ item, index, dataList, setDataListFromItem, ...customProps }) :
                                                        col.component({ item, index, dataList, setDataListFromItem, ...customProps })
                                                }


                                            </div>

                                        </div>)
                                    } else {

                                        return (<div className='d-flex justify-content-between' key={idx}>
                                            <label>{col.title}:</label>
                                            <span >{item[col.property]}</span></div>)
                                    }

                                }
                                )}

                            </div>
                        )

                    })
                }
            </div>
        )
    }

    return (

        <>
            {values.isExistContactDB && <GetContactDB ref={ref} setContact={(allCachedContact) => handleChange({ allCachedContact: allCachedContact })} />}
            <AddContact
                display={values.displayAddContactModal}
                number={values.numberToAddContact}
                setDisplay={() => handleChange({ displayAddContactModal: false })} />
            <div className='call-report-page ds-call-report' >
                <div className='p-2'>
                    <div className='d-flex justify-content-between'>

                        <div className='d-flex align-items-center'>
                            <h3 style={{ marginBottom: 0 }}>تماس‌ها</h3>

                        </div>

                    </div>

                    <CRow className='mt-3 mb-3 search-item'>
                        <CCol lg={2} xs={12}>
                            {/* <CFormLabel >از شماره</CFormLabel> */}
                            <CFormInput
                                type="text"
                                placeholder="از شماره..."
                                value={values.FromNumber}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (checkForNumericEnFaString(value)) {
                                        // for (let i = 0; i < value.length; i++) {
                                        value = persianToEnglishChar(value)
                                        // }
                                    }

                                    handleChange({ FromNumber: value })

                                }} />
                        </CCol>
                        <CCol lg={2} xs={12} className=' search-item'>
                            {/* <CFormLabel >به شماره</CFormLabel> */}
                            <CFormInput
                                type="text"
                                placeholder="به شماره..."
                                value={values.ToNumber}
                                onChange={(e) => handleChange({ ToNumber: persianToEnglishChar(e.target.value) })} />
                        </CCol>
                        <CCol lg={4} xs={12}>
                            <div className='text-center time-container'>
                                <CFormLabel htmlFor="exampleFormControlInput1">بازه زمانی</CFormLabel>

                                <LocalizationProvider
                                    dateAdapter={AdapterDateFnsJalali}
                                >

                                    <CRow>
                                        <CCol lg={6} xs={12} className='position-relative' >
                                            <DatePicker
                                                onChange={(unix) => {
                                                    setSDateVal(unix)
                                                    handleChange({ FromConnectTime: moment(unix).local('fa').format("jYYYY/jMM/jDD") })
                                                }}
                                                value={sDateVal}
                                                renderInput={(props) => (
                                                    <TextField {...props} />
                                                )}
                                                closeOnSelect
                                            />
                                            {values.FromConnectTime && <span className='remove-date-spn' onClick={() => {
                                                setSDateVal(null)
                                                handleChange({ FromConnectTime: null })
                                            }
                                            }><CloseSVG /></span>}
                                        </CCol>
                                        <CCol lg={6} xs={12} className='position-relative'>
                                            <DatePicker
                                                onChange={(unix, formatted) => {
                                                    setEDateVal(unix);
                                                    handleChange({ ToConnectTime: moment(unix).local('fa').format("jYYYY/jMM/jDD") })
                                                }}
                                                value={eDateVal}
                                                renderInput={(props) => (
                                                    <TextField {...props} />
                                                )}
                                            />
                                            {values.ToConnectTime && <span className='remove-date-spn' onClick={() => {
                                                setEDateVal(null)
                                                handleChange({ ToConnectTime: null })
                                            }
                                            }><CloseSVG /></span>}
                                        </CCol>

                                    </CRow>
                                </LocalizationProvider>




                            </div>
                        </CCol>
                        <CCol lg={2} xs={12}>
                            <CFormLabel htmlFor="exampleFormControlInput1">نوع</CFormLabel>

                            <CFormSelect
                                onChange={(e) => handleChange({ Type: e.target.value })}
                                className='form-control'
                                // defaultValue={values.role}
                                value={values.Type}>
                                <option value={"0"}>همه</option>
                                {callTypes?.map((item, idx) => {
                                    if (idx > 0) {
                                        return (<option key={idx} value={item.Value}>{item.Name}</option>)

                                    } else {
                                        return null
                                    }
                                }

                                )}

                            </CFormSelect>

                        </CCol>
                        <CCol lg={2} xs={12} >
                            <button className='btn btn-primary mt-4' onClick={handleSearch} >جستجو</button>
                        </CCol>
                    </CRow>
                    <div className='fa table-container'>
                        <GSPTable
                            columns={columns}
                            hasSorting={false}
                            apiCall={handleGetData}
                            dataList={callReportObj.data ? callReportObj : { data: [] }}
                            // options={options}
                            hasFiltering={false}
                            enableScrolling={false}
                            loading={getCallReportPending}
                            hasPaging={true}
                            pageSize={25}
                            setDataListFromItem={setCallReportObj}
                            // isStepScrolling={true}
                            externalPaging={Paging}
                            callAPIToExport={handleCallAppToExport}
                            customProps={{
                                cachedContacts: values.allCachedContact,
                                phonebookList: phonebookList?.data,
                                setNumberToAddContact: handleSetNumberToAddContact,
                                cardViewFromCompo,
                                cardViewToCompo,
                                handleChange

                            }}
                            exportDataModel={{
                                dataList: callREportToExport?.Calls?.Dto,
                                exportWaiting: getCallReportPending,
                                callAPIToExport: handleCallAppToExport,
                                fileName: "call_report",
                                success: successExport
                            }}
                            customLoading={() => <div className='custom-loading'>
                                <div>
                                    درحال بارگذاری...
                                    <div className="spinner-border" role="status" aria-hidden="true"></div>

                                </div>
                            </div>}
                            isDynamicColumns={true}
                            customCardView={customCardView}

                        />
                    </div>
                    <div className='mt-3'>
                        <div className="row">
                            {callReport?.Calls && <div className='p-2'
                            //  style="margin: -1px 15px;"
                            >
                                <table className="col-lg-12 col-xs-12 table table-bordered"
                                //  style="border-top: 2px solid gray;"
                                >
                                    <tbody>
                                        <tr>
                                            <td>منشی</td>
                                            <td>
                                                {callReport?.TotalSecretaryDuration}
                                                {callReport?.TotalSecretaryDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>تلفن گویا</td>
                                            <td>
                                                {callReport?.TotalIvrDuration}
                                                {callReport?.TotalIvrDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>صندوق صوتی</td>
                                            <td>
                                                {callReport?.TotalVoiceMailDuration}
                                                {callReport?.TotalVoiceMailDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>فکس</td>
                                            <td>
                                                {callReport?.TotalFaxDuration}
                                                {callReport?.TotalFaxDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>انتقال توسط منشی</td>
                                            <td>
                                                {callReport?.TotalTransferedBySecretaryDuration}
                                                {callReport?.TotalTransferedBySecretaryDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>انتقال توسط تلفن‌گویا</td>
                                            <td>
                                                {callReport?.TotalTransferedByIvrDuration}
                                                {callReport?.TotalTransferedByIvrDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>تماس خروجی مستقیم</td>
                                            <td>
                                                {callReport?.TotalTransferedByOutgoingCallDuration}
                                                {callReport?.TotalTransferedByOutgoingCallDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>انتقال تماس توسط همکار</td>
                                            <td>
                                                {callReport?.TotalMemberCallTransferDuration}
                                                {callReport?.TotalMemberCallTransferDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td> تماس توسط همکار</td>
                                            <td>
                                                {callReport?.TotalMemberCallDuration}
                                                {callReport?.TotalMemberCallDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>انتقال  توسط صف</td>
                                            <td>
                                                {callReport?.TotalQueueOperatorTransferDuration}
                                                {callReport?.TotalQueueOperatorTransferDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>

                                        <tr
                                            style={{ backgroundColor: '#d3d3d3' }}  >
                                            <td>جمع کل</td>
                                            <td>
                                                {callReport?.TotalDuration}
                                                {callReport?.TotalDuration > 0 && <span >دقیقه</span>}
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>}
                        </div>
                    </div>
                </div>
            </div >
        </>


    )
}


DSAppCallReport.propTypes = {
    getCallTypesPending: PropTypes.bool,
    getContactReportPending: PropTypes.bool,
    getCallReportPending: PropTypes.bool,

}

const mapStateToProps = (state) => ({
    getCallTypesPending: state.callReportReducer.getCallTypesPending,
    getContactReportPending: state.callReportReducer.getContactReportPending,
    getCallReportPending: state.callReportReducer.getCallReportPending,
    callReport: state.callReportReducer.callReport,
    contactReport: state.callReportReducer.contactReport,
    callTypes: state.callReportReducer.callTypes,
    callREportToExport: state.callReportReducer.callREportToExport,
    getCallReportToExportPending: state.callReportReducer.getCallREportToExportPending,
    successExport: state.callReportReducer.successGetDataExport,
    callReportFile: state.callReportReducer.callReportFile,




})

const mapDispatchToProps = (dispatch) => ({
    getReport: (params) => { dispatch(getCustomerCallsAction(params)) },
    getCallTypes: () => { dispatch(getCustomerCallTypesAction()) },
    getContactReport: () => { dispatch(getCustomerContactsAction()) },
    returnToOld: (id, path, page) => { dispatch(returnToOldId(id, path, page)) },
    getReportToExport: (params) => { dispatch(getCallReportToExport(params)) },
    getReportFile: (id) => { dispatch(getCallReportFileAction(id)) },
    getAllContacts: (params) => { dispatch(getAllContactsRequestAction(params)) }

})
export default connect(mapStateToProps, mapDispatchToProps)(DSAppCallReport)